import { InlineIcon } from '@iconify/react/dist/iconify.js'
import { FC, useContext, useRef } from 'react'
import "./style.css"
import { useTranslation } from 'react-i18next'
import { Context } from '../../context'
import SearchTools from './SearchTools'
import { ISearchWrapper } from './SearchWrapper.type'

const SearchWrapper: FC<ISearchWrapper> = ({ children, haveCustomPriority, needParams, onlyCustom }) => {

    const { t, i18n } = useTranslation()


    const { searchArea, searchData, setSearchData, customSearchData, setCustomSearchData, ToggleClearFeild, clearField } = useContext(Context)
    const { reloadTable, ToggleReloadTable } = useContext(Context)
    const prevSearchStatus = useRef(reloadTable)

    const handleClear = () => {
        const hasValues = (data: {}) => Object.values(data).some(value => value !== "");
        const ifSearchHaveValue = hasValues(searchData) || hasValues(customSearchData);
        if (ifSearchHaveValue && prevSearchStatus.current !== reloadTable) ToggleReloadTable(!reloadTable);
        let tempArr: any = []
        searchData.forEach((field: any) => {
            tempArr.push(
                {
                    accessor: field.accessor,
                    label: `${field?.["label"] || field["accessor"]}`,
                    value: "",
                }
            )
        })
        setSearchData(tempArr)
        !needParams && setCustomSearchData({})
        ToggleClearFeild(!clearField)
    }

    const handleToggle = () => {
        ToggleReloadTable(!reloadTable)
    }


    return (
        <div className={`search-section ${searchArea || "hideSearchArea"}`}>
            <div>
                <SearchTools onlyCustom={onlyCustom} haveCustomPriority={haveCustomPriority}>
                    {children}
                </SearchTools>
            </div>
            <div className='table-search-controller'>
                <button className='search-btn' onClick={handleToggle}>
                    {t('Search')}
                    <InlineIcon icon={`fluent:arrow-${i18n.language ? "left" : "right"}-32-filled`} className='table-search-icon' />
                </button>
                <button className='search-btn clear-btn' onClick={handleClear}>{t("Cancel")}</button>
            </div>
        </div>
    )
}

export default SearchWrapper